export default "__VITE_ASSET__N1oInl4B__"